import { Checkbox, FormControlLabel, FormHelperText, FormControl } from '@mui/material';

export interface CheckboxProps {
  label?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  error?: boolean;
  errorInfo?: string;
  autoFocus?: boolean;
  disabled?: boolean;
}

const CheckboxInput = ({ label, value, error = false, errorInfo, autoFocus = false, disabled, onChange }: CheckboxProps) => {
  return (
    <FormControl error={error} component="fieldset">
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            autoFocus={autoFocus}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          />
        }
        label={label}
      />
      {error && <FormHelperText>{errorInfo}</FormHelperText>}
    </FormControl>
  );
};

export default CheckboxInput;
